export default __webpack_public_path__ + "static/media/Group84115.3ac82393.svg";